export const getSubdomain = (): string => {
  const hostname = window.location.hostname;

  if (hostname.endsWith('.iserviceauto.com')) {
    return hostname.replace(/\.iserviceauto\.com$/, '').replace(/^www\./, '');
  }

  return hostname;
};
